import React from 'react';
import { Spinner } from '@honeycomb-npm/honeycomb-react';

type Props = {
  isLoaded?: boolean;
  children?: React.ReactNode;
  text?: string;
  id: string;
};

export const SpinnerWrapper = ({
    isLoaded,
    children,
    text,
    id,
}: Props): JSX.Element => (
    isLoaded && children
        ? (
            <>{children}</>
        )
        : (
            <div >
                <Spinner isVisible />
                {text && <p id={`${id}-loading-text`} className="Text20EmphasisCenter">{text}</p>}
            </div>
        )
);
